module.exports = __webpack_public_path__ + "img/rule.9e8c2c8e.jpg";